import axios from '@/lib/AxApi';

export default {
  getGlobals(cb)
  {
    axios.get('/rest/Session/returnJsVars')
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getGlobals(cb)
  {
    axios.get('/rest/Session/returnJsVars')
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  selectMyMessageCount(cb)
  {
    axios.get('/rest/WorkOrderTalks/selectMyMessageCount')
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  selectMyTasksCount(cb)
  {
    axios.get('/rest/WorkOrderTasks/selectMyTasksCount')
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  selectMyNotificationsCount(cb)
  {
    axios.get('/rest/Notifications/selectMyNotificationsCount')
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  login(data, cb)
  {
    axios.post('/rest/Session/logginUser', data)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  logout(cb)
  {
    axios.post('/rest/Session/logOut', {})
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  fetchLanguage(langCode, cb)
  {
    axios.get('/'+langCode+'/rest/Translator/getTranslationByLangCode',
    {
      params: {
        langCode: langCode
      }
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  checkTrans: function(key)
  {
    axios.post('/rest/Translator/checkTrans', {key: key})
  }
}



// WEBPACK FOOTER //
// ./src/api/globals.js